import React from 'react';
import { Collapsible, Button } from '@shopify/polaris';

import './card-settings.scss';

export default function CardSettings({ children, number = 2, setOpenSetting, title, type, open, actions }) {
  return (
    <div className='CartSettings'>
      <div className='card'>
        <div
          className={open ? 'card-header active' : 'card-header'}
          onClick={() => setOpenSetting(open !== type && type)}
        >
          <div className='CartSettings__Title'>
            <span className='number-card' data-num={number} />
            <span className='card-link'>{title}</span>
          </div>
          {actions && open === type && (
            <Button
              plain
              onClick={event => {
                event.stopPropagation();
                actions.onAction();
              }}
            >
              {actions.content}
            </Button>
          )}
        </div>
        <Collapsible
          open={open === type}
          id={`basic-collapsible-sales-pop-type-${number}`}
          transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
          expandOnPrint
        >
          <div className='card-body relative'>{children}</div>
        </Collapsible>
      </div>
    </div>
  );
}
